import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

import { Header } from '@app/sections/header';
import { Strings } from '@app/constants';
import { useTable } from '@app/components/table';
import { useRequestState, useSearch, useDialog } from '@app/hooks';
import { getDesignations } from '../slice';
import { selectDesignationState } from '../selectors';
import { DesignationList } from './designation-list';
import { AddDesignation } from './add-designation';
import { useAuthRolePermissions } from '@app/utils';

const DesignationListPage = () => {
  const tableProps = useTable();

  const addDesignationDialog = useDialog();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getDesignations());
  }, [dispatch]);

  const { data, loading } = useRequestState({
    stateSelector: selectDesignationState,
    errorShown: true,
  });

  const searchProps = useSearch({ data: data?.records, fields: ['name', 'id'] });
  const { hasPermission } = useAuthRolePermissions();
  const canAddDesignation = hasPermission('Designations', 'w');

  return (
    <>
      <Header
        title={Strings.page_title.designations}
        helperText={''}
        actionButtonTitle={canAddDesignation ? Strings.button.addDesignation : undefined}
        onClickActionButton={addDesignationDialog.show}
        searchBarProps={{
          placeholder: Strings.common.search,
          onChange: searchProps.handleSearchChange,
        }}
      />
      <DesignationList
        loading={loading}
        tableProps={tableProps}
        rows={searchProps.filteredRows}
        canAddDesignation={canAddDesignation}
      />

      {addDesignationDialog.visible && (
        <AddDesignation open={addDesignationDialog.visible} onClose={addDesignationDialog.hide} />
      )}
    </>
  );
};

export { DesignationListPage };
